<template>
    <div>
        <folderPage type="activity"/>
    </div>
</template>

<script>
import folderPage from '@/modules/business/folders/views/list.vue'
export default {
  components: {
    folderPage
  }
}
</script>
